import { entriesEndpoint } from '@/ui/core/config'
import { Entry, EntrySchema } from '@/shared/types'
import { GuestbookClient } from '../GuestbookClient'

export async function listEntries(
  this: GuestbookClient,
  eventId: string,
): Promise<Entry[]> {
  if (eventId === '') {
    throw new Error('Missing Event')
  }
  const jwtToken = (await this.auth.getJWT()) ?? ''
  const params = new URLSearchParams({ eventId }).toString()
  const endpoint = `${entriesEndpoint}?${params}`
  const result = await fetch(endpoint, {
    method: 'GET',
    headers: {
      Authorization: jwtToken,
    },
  })

  const entries = EntrySchema.array().parse(await result.json())
  return entries
}
